import { Contract } from '@ethersproject/contracts'
import { getContract } from '../utils'
import { useMemo } from 'react'
import { useActiveWeb3React } from './useActiveWeb3React'
import CUSTODIAN_ABI from '../constants/abis/custodian.json'
import DEXABI from '../constants/abis/abiDEX.json'
import TOKENABI from '../constants/abis/token.json'
import BONUSABI from '../constants/abis/bonus.json'
import { 
  CUSTODIAN_ADDRESS,
  DEX_Address,
  GOV_TOKEN,
  BONUS_ADDRESS
} from '../constants/'


// returns null on errors
function useContract(address: string | undefined, ABI: any, withSignerIfPossible = true): Contract | null {
    const { library, account } = useActiveWeb3React()
  
    return useMemo(() => {
      if (!address || !ABI || !library) return null
      try {
        return getContract(address, ABI, library, withSignerIfPossible && account ? account : undefined)
      } catch (error) {
        console.error('Failed to get contract', error)
        return null
      }
    }, [address, ABI, library, withSignerIfPossible, account])
  }
  

  export function useCustodainContract(): Contract | null {
    return useContract( CUSTODIAN_ADDRESS  , CUSTODIAN_ABI, true)
  }

  export function useDexContract(): Contract | null {
    return useContract(  DEX_Address , DEXABI, true)
  }
    
  export function useTokenContract(): Contract | null {
    return useContract( GOV_TOKEN , TOKENABI , true)
  }

  export function useBonusContract(): Contract | null {
    return useContract( BONUS_ADDRESS, BONUSABI, true)
  }